export default __webpack_public_path__ + "static/media/isa-06.d4c245e1.jpg";